var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading ? _c("div", [_c("loading-spinner")], 1) : _vm._e(),
    _vm._v(" "),
    !_vm.loading
      ? _c(
          "div",
          [
            _c("b-breadcrumb", { attrs: { items: _vm.navigationItems } }),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "create-publisher",
                attrs: { id: "create-publisher", title: "Create Publisher" },
                on: {
                  show: _vm.resetModal,
                  hidden: _vm.resetModal,
                  ok: _vm.handleCreateOk
                }
              },
              [
                _c("p", [
                  _vm._v(
                    "This will create a new publisher with a randomly generated unique ID."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    ref: "createForm",
                    on: {
                      submit: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleCreateSubmit($event)
                      }
                    }
                  },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          state: _vm.state.name,
                          label: "Publisher Name",
                          "label-for": "name-create",
                          "invalid-feedback": "Name is required"
                        }
                      },
                      [
                        _c("b-form-input", {
                          ref: "nameCreate",
                          attrs: {
                            id: "name-create",
                            state: _vm.state.name,
                            required: ""
                          },
                          model: {
                            value: _vm.publisher.name,
                            callback: function($$v) {
                              _vm.$set(_vm.publisher, "name", $$v)
                            },
                            expression: "publisher.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          state: _vm.state.description,
                          label: "Publisher Description",
                          "label-for": "description-create",
                          "invalid-feedback": "Description is required"
                        }
                      },
                      [
                        _c("b-form-input", {
                          ref: "descriptionCreate",
                          attrs: {
                            id: "description-create",
                            state: _vm.state.description,
                            required: ""
                          },
                          model: {
                            value: _vm.publisher.description,
                            callback: function($$v) {
                              _vm.$set(_vm.publisher, "description", $$v)
                            },
                            expression: "publisher.description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "editPublisher",
                attrs: { id: "edit-publisher", title: "Edit Publisher" },
                on: { hidden: _vm.resetModal, ok: _vm.handleEditOk }
              },
              [
                _c(
                  "form",
                  {
                    ref: "editForm",
                    on: {
                      submit: function($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.handleEditSubmit($event)
                      }
                    }
                  },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          state: _vm.state.name,
                          label: "Edit Publisher Name",
                          "label-for": "name-edit",
                          "invalid-feedback": "Name is required"
                        }
                      },
                      [
                        _c("b-form-input", {
                          ref: "nameEdit",
                          attrs: {
                            id: "name-edit",
                            state: _vm.state.name,
                            required: ""
                          },
                          model: {
                            value: _vm.publisher.name,
                            callback: function($$v) {
                              _vm.$set(_vm.publisher, "name", $$v)
                            },
                            expression: "publisher.name"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          state: _vm.state.description,
                          label: "Edit Publisher Description",
                          "label-for": "description-edit",
                          "invalid-feedback": "Description is required"
                        }
                      },
                      [
                        _c("b-form-input", {
                          ref: "descriptionEdit",
                          attrs: {
                            id: "description-edit",
                            state: _vm.state.description,
                            required: ""
                          },
                          model: {
                            value: _vm.publisher.description,
                            callback: function($$v) {
                              _vm.$set(_vm.publisher, "description", $$v)
                            },
                            expression: "publisher.description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "deletePublisher",
                attrs: {
                  id: "delete-publisher",
                  title: "Delete Publisher Configurations"
                },
                on: { ok: _vm.handleDeleteOK, hidden: _vm.resetModal }
              },
              [
                _c("p", [
                  _vm._v("Are you sure you want to delete : "),
                  _c("b", [_vm._v(_vm._s(_vm.publisher.name))])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "b-container",
              [
                _c("b-row", [_c("h2", [_vm._v("Publisher Selection")])]),
                _vm._v(" "),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "form-row", attrs: { cols: "6" } },
                      [
                        _c("p", [
                          _vm._v(
                            "Select a publisher to configure payment options or a create a new one."
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "ml-2",
                            attrs: { plain: "" },
                            model: {
                              value: _vm.showExpiring,
                              callback: function($$v) {
                                _vm.showExpiring = $$v
                              },
                              expression: "showExpiring"
                            }
                          },
                          [_vm._v("\n            Show Expiring\n          ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      {
                        staticClass: "text-right align-self-center",
                        attrs: { cols: "3" }
                      },
                      [
                        _c("label", { attrs: { for: "table-search" } }, [
                          _vm._v("Search:")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "3" } },
                      [
                        _c("b-form-input", {
                          attrs: { id: "table-search", type: "text" },
                          model: {
                            value: _vm.search,
                            callback: function($$v) {
                              _vm.search = $$v
                            },
                            expression: "search"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { attrs: { "align-v": "center" } },
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12", "align-h": "start" } },
                          [
                            _c("b-table", {
                              directives: [
                                {
                                  name: "b-scrollspy",
                                  rawName: "v-b-scrollspy"
                                }
                              ],
                              attrs: {
                                outlined: "",
                                striped: "",
                                items: _vm.filteredItems,
                                "head-variant": "light",
                                fields: _vm.computeTableFields,
                                filter: _vm.search,
                                "show-empty": "",
                                "empty-text": "No clients available"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "cell(clientId)",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "router-link",
                                          {
                                            staticClass: "navigation-links",
                                            attrs: {
                                              to: {
                                                name: "configuration",
                                                params: {
                                                  clientName: data.item.name,
                                                  clientId: data.item.clientId
                                                }
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(data.item.clientId) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(expiresAt)",
                                    fn: function(data) {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              data.item.expiresAt.toLocaleDateString()
                                            ) +
                                            " " +
                                            _vm._s(
                                              data.item.expiresAt.toLocaleTimeString()
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    }
                                  },
                                  {
                                    key: "cell(action)",
                                    fn: function(data) {
                                      return [
                                        _c(
                                          "b-link",
                                          {
                                            directives: [
                                              {
                                                name: "b-modal",
                                                rawName: "v-b-modal",
                                                value: "edit-publisher",
                                                expression: "'edit-publisher'"
                                              }
                                            ],
                                            staticClass: "navigation-links",
                                            on: {
                                              click: function($event) {
                                                return _vm.updatePublisher(
                                                  data.item
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  Edit\n                "
                                            )
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                |\n                "
                                        ),
                                        !data.item.expiresAt
                                          ? _c(
                                              "b-link",
                                              {
                                                directives: [
                                                  {
                                                    name: "b-modal",
                                                    rawName: "v-b-modal",
                                                    value: "delete-publisher",
                                                    expression:
                                                      "'delete-publisher'"
                                                  }
                                                ],
                                                staticClass: "navigation-links",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updatePublisher(
                                                      data.item
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Delete\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        data.item.expiresAt
                                          ? _c(
                                              "b-link",
                                              {
                                                staticClass: "navigation-links",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.restoreClient(
                                                      data.item.clientId
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  Restore\n                "
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                1406261501
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("br")
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-action-ct" },
                  [
                    _c(
                      "b-button",
                      {
                        directives: [
                          {
                            name: "b-modal",
                            rawName: "v-b-modal.create-publisher",
                            modifiers: { "create-publisher": true }
                          }
                        ],
                        attrs: { variant: "primary" }
                      },
                      [
                        _c("i", { staticClass: "fa fa-plus-circle" }),
                        _vm._v(" Create New Publisher\n        ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "settings" } } },
                      [
                        _c(
                          "b-button",
                          { staticClass: "ml-3", attrs: { variant: "info" } },
                          [
                            _c("i", { staticClass: "fa fa-cog" }),
                            _vm._v(" Settings\n          ")
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }